export const PUBLICATION_CLIPBOARD_TYPE = "publication";
export default class Clipboard {
  static async getFormattedClipboardItems() {
    let formattedItems = [];
    const clipboardItems = await navigator.clipboard.read();

    for (const clipboardItem of clipboardItems) {
      for (const type of clipboardItem.types) {
        const item = await clipboardItem.getType(type);
        const parsedItem = JSON.parse(await item.text());

        if (Array.isArray(parsedItem)) {
          return parsedItem;
        }

        formattedItems.push(parsedItem);
      }
    }
    return formattedItems;
  }

  static copyToClipboard(itemsToAppend, clipboardAction, contentsType) {
    const stringItems = JSON.stringify(itemsToAppend.map(item => {
      return {
        action: clipboardAction,
        contents: item,
        type: contentsType,
      };
    }));
    navigator.clipboard.writeText(stringItems);
  }
}
